import { useAuthStore } from '~/stores/auth.store'

const nameForAuthUser = ['profile', 'orders', 'favourites', 'notifications']

const nameForNotAuthUser = [
    'login',
    'registration',
    'password-reset',
    'password-forgot',
]
export default defineNuxtRouteMiddleware((to) => {
    const { isAuth } = storeToRefs(useAuthStore())
    const routeName = typeof to.name === 'string' ? to.name : ''

    useAuthStore().check()

    if (isAuth.value && nameForNotAuthUser.includes(routeName)) {
        return navigateTo('/profile')
    }
    if (!isAuth.value && nameForAuthUser.includes(routeName)) {
        return navigateTo('/login')
    }
})
